export default __webpack_public_path__ + "static/media/DTMEDIA Pricing Plan - Annual-1.04ebb883.png";